import { MenuItemType } from '@/types';

/**
 * Checks if a menu item is currently pinned
 */
export const isMenuItemPinned = (item: MenuItemType, pinnedIds: string[]): boolean => {
    return pinnedIds.includes(item.id);
};

/**
 * Calculates the next pinned navigation state after toggling an item
 */
export const calculateNextPinnedState = (
    currentPinned: { id: string }[],
    itemId: string,
    isPinned: boolean
): { id: string }[] => {
    if (isPinned) {
        return currentPinned.filter(p => p.id !== itemId);
    }
    return [...currentPinned, { id: itemId }];
};

/**
 * Builds the community URL with token
 */
export const buildCommunityUrl = (
    communityDomain: string,
    communitySlug: string,
    hasMultipleCommunities: boolean,
    token: string
): string => {
    const destinationPage = hasMultipleCommunities ? '' : communitySlug;
    return `${communityDomain}${destinationPage}?token=${token}`;
};
